import { ChangeDetectionStrategy, Component, ViewEncapsulation, inject } from '@angular/core';
import { MatIconButton } from '@angular/material/button';

import { SvgIconComponent } from '@dmb/core';

import { ButtonComponent } from '../components/form/button/button.component';
import { PopupCenterService } from './popup-center.service';

@Component({
  selector: 'dmb-popup-center',
  templateUrl: './popup-center.component.html',
  styleUrl: './popup-center.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  imports: [ButtonComponent, MatIconButton, SvgIconComponent],
})
export class PopupCenterComponent {
  popupCenterService = inject(PopupCenterService);
}
